import $ from 'jquery';
import debounce from 'lodash/debounce';
import registerJQueryPlugin from '../lib/register-jquery-plugin';

export const PLUGIN_NAME = 'horizontalScroll';
export const DEFAULTS = {
  type: '',
};

const isInViewport = ($el) => {
  const elTop = $el.offset().top;
  const elBottom = elTop + $el.outerHeight();
  const elLeft = $el.offset().left;
  const elRight = elLeft + $el.outerWidth();
  const vpTop = $(window).scrollTop();
  const vpBottom = vpTop + $(window).height();
  const vpLeft = 0;
  const vpRight = $(window).width();
  return elBottom > vpTop && elTop < vpBottom && elLeft < vpRight && elRight > vpLeft;
};


const showImage = ($el, key) => {
  const $lazyImages = $el.find('img[data-lazy]').not('.loaded');
  if (!$lazyImages.length) {
    $(window).off(`scroll.horizontalScroll-${key}`);
    $($el).off(`scroll.horizontalScroll-${key}`);
  }
  $lazyImages.each(function eachLazyImage() {
    const $lazyImage = $(this);
    if (isInViewport($lazyImage)) {
      $lazyImage.attr('src', $lazyImage.attr('data-lazy')).addClass('loaded');
    }
  });
};
const onWindowScroll = ($el, key) => {
  $(window).on(`scroll.horizontalScroll-${key}`, () => {
    showImage($el, key);
  });
};
const scrollEvent = ($el, opts) => () => {
  const $image = $el.find('img');
  const imageIndexes = [];
  $image.each(function eachImage() {
    const $thisImage = $(this);
    const imageIndex = $thisImage.closest('.horizontal-scroll__item').index();
    if (isInViewport($thisImage)) {
      imageIndexes.push(imageIndex + 1);
    }
  });
  const carouselEvent = new CustomEvent('carouselChange');
  carouselEvent.tracking = {
    type: opts.type,
    currentSlide: imageIndexes[imageIndexes.length - 1],
    pageUrl: window.location.href,
    pageTitle: document.title,
    element: $el,
  };
  window.dispatchEvent(carouselEvent);
};
const onHorizontalScroll = ($el, key, opts) => {
  const trackingScroll = scrollEvent($el, opts);
  $($el).on(`scroll.horizontalScroll-${key}`, () => {
    showImage($el, key);
  });
  $($el).on(`scroll.horizontalEventScroll-${key}`, debounce(trackingScroll, 500));
};
const addEventListeners = ($el, key, opts) => {
  onWindowScroll($el, key);
  onHorizontalScroll($el, key, opts);
};
const init = ($el, opts) => {
  const key = `key-${Math.ceil(Math.random() * 10000000000)}`;
  $el.find('img[data-lazy]').addClass('horizontal-scroll__lazy-image');
  showImage($el, key);
  addEventListeners($el, key, opts);
};
const mergeOptions = ($el, options = {}) => {
  const opts = $.extend({}, DEFAULTS, $el.data(), options);
  return opts;
};
export default function horizontalScroll(el, options = {}) {
  const $el = $(el);
  const opts = mergeOptions($el, options);
  init($el, opts);
}
registerJQueryPlugin(PLUGIN_NAME, horizontalScroll);



// WEBPACK FOOTER //
// ./styleguide/src/assets/modules/horizontal-scroll.js